module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-rank_3.png?v=ea9c9517";